import { type z } from "zod"
import { type ProductCodeSchema } from "../schemas/productCode"

export type ProductCode = z.infer<typeof ProductCodeSchema>

export const ProductCode = {
    COCON_SAISONNALISE_BASE_AOUT26_B: "COCON_SAISONNALISE_BASE_AOUT26_B",
    COCON_SAISONNALISE_HPHC_AOUT26_B: "COCON_SAISONNALISE_HPHC_AOUT26_B",
    COCON_SAISONNALISEE_AOUT26: "COCON_SAISONNALISEE_AOUT26",
    COCON_FALLBACK_AOUT26: "COCON_FALLBACK_AOUT26",
    DRIVE_PACK: "DRIVE_PACK",
    DRIVE_PACK_FIXE: "DRIVE_PACK_FIXE",
    DRIVE_PACK_FIXE_FEVRIER: "DRIVE_PACK_FIXE_FEVRIER",
    DRIVE_PACK_FIXE_44_AVRIL26: "DRIVE_PACK_FIXE_44_AVRIL26",
    DRIVEPACK_POWERDOT_49_JUIN26: "DRIVEPACK_POWERDOT_49_JUIN26",
    EARLY_BIRD: "EARLY_BIRD",
    ECO_CONSO_1: "ECO_CONSO_1",
    ECO_CONSO_BIS: "ECO_CONSO_BIS",
    ECO_CONSO_FIXE_3: "ECO_CONSO_FIXE_3",
    ECO_CONSO_FIXE_4_B: "ECO_CONSO_FIXE_4_B",
    ECO_CONSO_FIXE_6: "ECO_CONSO_FIXE_6",
    ECO_CONSO_FIXE_6_AOUT25: "ECO_CONSO_FIXE_6_AOUT25",
    ECO_CONSO_FIXE_10_ROLLOVERUFC: "ECO_CONSO_FIXE_10_ROLLOVERUFC",
    ECO_CONSO_FIXE_12_B_FEVRIER: "ECO_CONSO_FIXE_12_B_FEVRIER",
    ECO_CONSO_FIXE_15: "ECO_CONSO_FIXE_15",
    ECO_CONSO_FIXE_20: "ECO_CONSO_FIXE_20",
    ECO_CONSO_FIXE_22_CONQUETE: "ECO_CONSO_FIXE_22_CONQUETE",
    ECO_CONSO_FIXE_22_CONQUÊTE: "ECO_CONSO_FIXE_22_CONQUÊTE",
    ECO_CONSO_FIXE_22: "ECO_CONSO_FIXE_22",
    ECO_CONSO_FIXE_25_CONQUETE: "ECO_CONSO_FIXE_25_CONQUETE",
    ECO_CONSO_FIXE_25_CONQUÊTE: "ECO_CONSO_FIXE_25_CONQUÊTE",
    ECO_CONSO_FIXE_25: "ECO_CONSO_FIXE_25",
    ECO_CONSO_FIXE_26: "ECO_CONSO_FIXE_26",
    ECO_CONSO_FIXE_26_FEVRIER: "ECO_CONSO_FIXE_26_FEVRIER",
    ECO_CONSO_FIXE_29_AG: "ECO_CONSO_FIXE_29_AG",
    ECO_CONSO_FIXE_29: "ECO_CONSO_FIXE_29",
    ECO_CONSO_FIXE_2ANS_TESTROLLOVER_ANTICIPE_1: "ECO_CONSO_FIXE_2ANS_TESTROLLOVER_ANTICIPE_1",
    ECO_CONSO_FIXE_3ANS_TESTROLLOVER_ANTICIPE_2: "ECO_CONSO_FIXE_3ANS_TESTROLLOVER_ANTICIPE_2",
    ECO_CONSO_FIXE_3ANS_SEPTEMBRE26_V2: "ECO_CONSO_FIXE_3ANS_SEPTEMBRE26_V2",
    ECO_CONSO_FIXE: "ECO_CONSO_FIXE",
    ECO_CONSO_GAZ_10: "ECO_CONSO_GAZ_10",
    ECO_CONSO_GAZ_FIXE: "ECO_CONSO_GAZ_FIXE",
    ECO_CONSO_GAZ: "ECO_CONSO_GAZ",
    ECO_CONSO_PLUS: "ECO_CONSO_PLUS",
    ECO_CONSO: "ECO_CONSO",
    EMCE_2023_22: "EMCE_2023_22",
    EMCE_2023: "EMCE_2023",
    EMCE_2023_26: "EMCE_2023_26",
    EMCE_2025: "EMCE_2025",
    GAZ_FIXE_RETENTION: "GAZ_FIXE_RETENTION",
    GAZ_INDEXE_RETENTION: "GAZ_INDEXE_RETENTION",
    HAPPY_CHARGE_2: "HAPPY_CHARGE_2",
    HAPPY_CHARGE: "HAPPY_CHARGE",
    INTELLIGENT_OCTOPUS: "INTELLIGENT_OCTOPUS",
    INTELLIGENT_OCTOPUS_FIXE: "INTELLIGENT_OCTOPUS_FIXE",
    INTELLIGENT_OCTOPUS_FIXE_FEVRIER: "INTELLIGENT_OCTOPUS_FIXE_FEVRIER",
    INTELLIGENT_OCTOPUS_FIXE_FEVRIER_AOUT26: "INTELLIGENT_OCTOPUS_FIXE_FEVRIER_AOUT26",
    OCTOFLEX_4: "OCTOFLEX_4",
    OCTOPUS_GO: "OCTOPUS_GO",
    OCTOSUMMER: "OCTOSUMMER",
    OFFRE_SEUIL: "OFFRE_SEUIL",
    ROLLOVER_ANTICIPE_SEPT26: "ROLLOVER_ANTICIPE_SEPT26",
} as const satisfies Record<ProductCode, ProductCode>
